import { render, staticRenderFns } from "./guidance.vue?vue&type=template&id=4d3a0ab0&scoped=true&"
import script from "./guidance.vue?vue&type=script&lang=js&"
export * from "./guidance.vue?vue&type=script&lang=js&"
import style0 from "./guidance.vue?vue&type=style&index=0&id=4d3a0ab0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3a0ab0",
  null
  
)

export default component.exports